var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("picture", { staticClass: "animation-number" }, [
    _c("source", {
      attrs: {
        media: "(min-width: 1280px)",
        srcset: "/img/" + _vm.src + "-" + _vm.index + "@dt.png"
      }
    }),
    _c("source", {
      attrs: {
        media: "(min-width: 768px)",
        srcset: "/img/" + _vm.src + "-" + _vm.index + ".png"
      }
    }),
    _c("img", {
      attrs: { src: "/img/" + _vm.src + "-" + _vm.index + ".png", alt: "" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a2980d1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2980d1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/ShapeNumberItem.vue
// module id = FvEg
// module chunks = 0 2